import {
  FETCH_CATEGORIES_REQUEST,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_FAILURE,
  SAVE_CATEGORY_REQUEST,
  SAVE_CATEGORY_SUCCESS,
  SAVE_CATEGORY_FAILURE,
  DELETE_CATEGORY_REQUEST,
  DELETE_CATEGORY_SUCCESS,
  DELETE_CATEGORY_FAILURE,
} from './types';

const INITIAL_STATE = {
  categoryList: [],
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_CATEGORIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        categoryList: action.payload,
      };

    case FETCH_CATEGORIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        categoryList: [],
      };
    case SAVE_CATEGORY_REQUEST:
      return {
        ...state,
        error: null,
      };

    case SAVE_CATEGORY_SUCCESS:
      return {
        ...state,
      };

    case SAVE_CATEGORY_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    case DELETE_CATEGORY_REQUEST:
      return {
        ...state,
        error: null,
      };

    case DELETE_CATEGORY_SUCCESS:
      return {
        ...state,
      };

    case DELETE_CATEGORY_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
